import { useTranslation } from 'react-i18next';

import { SitterRate } from 'us-web-services/dist/types/SitterRate';
import { PublicJobItem } from 'us-web-services/dist/types/PublicJob';

export const getRate = (rates?: SitterRate[], numberOfChildren?: number): number => {
  const sitterRates = rates || [];
  for (let i = sitterRates.length - 1; i >= 0; i--) {
    const rate = sitterRates[i];
    if ((rate?.minimumRate ?? 0) > 0 && (rate?.kidCount ?? 0) <= (numberOfChildren || 1)) {
      return rate!.minimumRate!;
    }
  }

  return 0;
};

export const GetRateString = (job: PublicJobItem): string => {
  const { t } = useTranslation();

  const numHours = (new Date(job.endDate!).getTime() - new Date(job.startDate!).getTime()) / 3600000 || 0;
  const jobRate = job.rate ? job.rate.toString() : 0;

  let rateString = '';

  if (jobRate) {
    const jobHours = job.type === 'one_time' ? numHours : job.minimumHours;

    rateString += t('components.jobCard.jobRate', { jobRate });

    if (jobHours) rateString += ` ${t('components.jobCard.jobHours', { jobHours })}`;
  } else {
    rateString += t('components.jobCard.negotiableRate');
  }

  return rateString;
};
